// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input-form-field {
  position: relative;
  display: flex;
  align-items: center;
  margin: var(--element-spacing) 0;
  line-height: 22px;
}
input-form-field label {
  width: 100%;
}
input-form-field.required h4::after {
  content: "*";
  color: var(--motes-light-red);
}
input-form-field .text-field {
  display: inline;
  width: 100%;
  box-sizing: border-box;
  border: solid 1px var(--motes-gray);
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
  padding: var(--motes-padding);
  font-family: var(--text-font);
  font-size: 16px;
  height: 43px;
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  /* Internet Explorer 10-11 */
  /* Microsoft Edge */
}
input-form-field .text-field.with-side {
  padding-right: 30px;
}
input-form-field .text-field.with-count {
  padding-right: 70px;
}
input-form-field .text-field.error {
  border-color: var(--motes-light-red);
}
input-form-field .text-field::placeholder {
  color: var(--motes-gray);
  opacity: 1; /* Firefox */
}
input-form-field .text-field:-ms-input-placeholder {
  color: var(--motes-gray);
}
input-form-field .text-field::-ms-input-placeholder {
  color: var(--motes-gray);
}
input-form-field input, input-form-field textarea, input-form-field h4, input-form-field p {
  transition: 0.2s;
}
input-form-field input:disabled, input-form-field input.disabled, input-form-field textarea:disabled, input-form-field textarea.disabled, input-form-field h4:disabled, input-form-field h4.disabled, input-form-field p:disabled, input-form-field p.disabled {
  color: var(--motes-gray);
}
input-form-field textarea {
  resize: none;
  overflow-y: hidden;
  line-height: 22px;
}
input-form-field p.description {
  margin-bottom: var(--motes-padding);
}
input-form-field .input-container {
  display: flex;
  align-items: center;
  margin-top: var(--mini-spacing);
}
input-form-field svg-icon, input-form-field .character-count {
  display: inline;
  position: absolute;
  right: var(--motes-padding);
  transition: 0.2s transform;
}
input-form-field .character-count {
  position: absolute;
  bottom: var(--motes-padding);
  color: var(--motes-gray);
  transition: 500ms color;
}
input-form-field .character-count.highlight {
  transition: 0ms;
  color: var(--motes-light-red);
}
input-form-field svg-icon {
  color: var(--motes-black);
  cursor: pointer;
}
input-form-field svg-icon:hover {
  transform: scale(1.2);
}
input-form-field svg-icon svg {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/input-form-field/input-form-field.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,YAAA;EACA,6BAAA;AAAR;AAGI;EACI,eAAA;EACA,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,oCAAA;EACA,mCAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EAcA,yCAAA;EAMA,4BAAA;EAKA,mBAAA;AAvBR;AAAQ;EACI,mBAAA;AAEZ;AACQ;EACI,mBAAA;AACZ;AAEQ;EACI,oCAAA;AAAZ;AAIQ;EACI,wBAAA;EACA,UAAA,EAAA,YAAA;AAFZ;AAMQ;EACI,wBAAA;AAJZ;AAQQ;EACI,wBAAA;AANZ;AAUI;EACI,gBAAA;AARR;AAUQ;EACI,wBAAA;AARZ;AAYI;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;AAVR;AAaI;EACI,mCAAA;AAXR;AAcI;EACI,aAAA;EACA,mBAAA;EACA,+BAAA;AAZR;AAeI;EACI,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AAbR;AAgBI;EACI,kBAAA;EACA,4BAAA;EACA,wBAAA;EACA,uBAAA;AAdR;AAgBQ;EACI,eAAA;EACA,6BAAA;AAdZ;AAkBI;EACI,yBAAA;EACA,eAAA;AAhBR;AAkBQ;EACI,qBAAA;AAhBZ;AAmBQ;EACI,aAAA;AAjBZ","sourcesContent":["input-form-field {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin: var(--element-spacing) 0;\n    line-height: 22px;\n\n    label {\n        width: 100%;\n    }\n\n    &.required h4::after {\n        content: \"*\";\n        color: var(--motes-light-red);\n    }\n\n    .text-field {\n        display: inline;\n        width: 100%;\n        box-sizing: border-box;\n        border: solid 1px var(--motes-gray);\n        background-color: var(--motes-white);\n        border-radius: var(--border-radius);\n        padding: var(--motes-padding);\n        font-family: var(--text-font);\n        font-size: 16px;\n        height: 43px;\n\n        &.with-side {\n            padding-right: 30px;\n        }\n\n        &.with-count {\n            padding-right: 70px;\n        }\n\n        &.error {\n            border-color: var(--motes-light-red);\n        }\n\n        /* Chrome, Firefox, Opera, Safari 10.1+ */\n        &::placeholder {\n            color: var(--motes-gray);\n            opacity: 1; /* Firefox */\n        }\n\n        /* Internet Explorer 10-11 */\n        &:-ms-input-placeholder {\n            color: var(--motes-gray);\n        }\n\n        /* Microsoft Edge */\n        &::-ms-input-placeholder {\n            color: var(--motes-gray);\n        }\n    }\n\n    input, textarea, h4, p {\n        transition: 0.2s;\n\n        &:disabled, &.disabled {\n            color: var(--motes-gray);\n        }\n    }\n\n    textarea {\n        resize: none;\n        overflow-y: hidden;\n        line-height: 22px;\n    }\n\n    p.description {\n        margin-bottom: var(--motes-padding);\n    }\n\n    .input-container {\n        display: flex;\n        align-items: center;\n        margin-top: var(--mini-spacing);\n    }\n\n    svg-icon, .character-count {\n        display: inline;\n        position: absolute;\n        right: var(--motes-padding);\n        transition: 0.2s transform;\n    }\n\n    .character-count {\n        position: absolute;\n        bottom: var(--motes-padding);\n        color: var(--motes-gray);\n        transition: 500ms color;\n\n        &.highlight {\n            transition: 0ms;\n            color: var(--motes-light-red);\n        }\n    }\n\n    svg-icon {\n        color: var(--motes-black);\n        cursor: pointer;\n\n        &:hover {\n            transform: scale(1.2);\n        }\n\n        svg {\n            display: flex;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
